export const INDIA_STATE_CODES = {
    "Andhra Pradesh": 28,
    "Arunachal Pradesh": 12,
    "Assam": 18,
    "Bihar": 10,
    "Chhattisgarh": 22,
    "Goa": 30,
    "Gujarat": 24,   // ✅ YOU WANTED THIS
    "Haryana": 6,
    "Himachal Pradesh": 2,
    "Jharkhand": 20,
    "Karnataka": 29,
    "Kerala": 32,
    "Madhya Pradesh": 23,
    "Maharashtra": 27,
    "Manipur": 14,
    "Meghalaya": 17,
    "Mizoram": 15,
    "Nagaland": 13,
    "Odisha": 21,
    "Punjab": 3,
    "Rajasthan": 8,
    "Sikkim": 11,
    "Tamil Nadu": 33,
    "Telangana": 36,
    "Tripura": 16,
    "Uttar Pradesh": 9,
    "Uttarakhand": 5,
    "West Bengal": 19,
    "Delhi": 7,
    "Jammu and Kashmir": 1,
    "Ladakh": 37,
    "Puducherry": 34,
    "Chandigarh": 4,
    "Dadra and Nagar Haveli and Daman and Diu": 26,
    "Andaman and Nicobar Islands": 35
};

export const LAIE_OPTIONS = [
    {
        value: "1",
        label: "Liability"
    },
    {
        value: "2",
        label: "Asset"
    },
    {
        value: "3",
        label: "Income"
    },
    {
        value: "4",
        label: "Expense"
    }
]

export const LAIE_MAPPING = {
    "1": 'Liability',
    "2": 'Asset',
    "3": 'Income',
    "4": 'Expense',
};